import { AddMeterSearchField } from "../type/type";
import { EMAIL_DOMAIN_REGEX, EMAIL_REGEX } from "./validation.constants";

export const REPORT_PERIOD = [
  // { value: "", label: "Select Period" },
  { value: "hour", label: "Hour" },
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

export const REPORT_VIEW_METER_SERIAL = [
  // { value: "", label: "Select Meter Serial" },
  { value: "METER_SERIAL_NUMBER", label: "Meter Serial Number" },
  { value: "METER_PROPERTY_NUMBER", label: "Meter Property Number" },
  { value: "NMI", label: "NMI" },
  { value: "CUSTOM_PROPERTY", label: "Custom Property" },
];

export const REPORT_VIEW_MSATS = [
  // { value: "", label: "Select MSATS Load DateTime" },
  {
    value: "Use Report execution time",
    label: "Use Report execution time",
  },
  { value: "Custom", label: "Custom" },
];

export const MISSING_DATA_HANDLING_NEM12 = [
  // { value: "", label: "Select Missing Data Handling" },
  { value: "USE_SUBSTITUTION", label: "Use substitution" },
  { value: "LOCF", label: "Interpolate (LOCF)" },
  { value: "LINEAR", label: "Interpolate - Linear" },
  { value: "INSERT_AS_NULL", label: "Insert as Null" },
];

export const NEGATIVE_DATA_HANDLING = [
  { value: "NONE", label: "None" },
  { value: "ZERO", label: "Convert to Zero" },
];

export const ROW_INTERVAL_OPTIONS = [
  { value: "300", label: "300" },
  { value: "500", label: "500" },
];

export const STATUS_OPTIONS = ["Active", "Inactive"];

export const STANDARD_DATE_TIME_FORMAT = [
  // { label: "Select Reading Date Format", value: "" },
  {
    value: "dd/MM/yyyy HH:mm:ss",
    label: "dd/MM/yyyy HH:mm:ss",
  },
  {
    value: "dd-MM-yyyy HH:mm:ss",
    label: "dd-MM-yyyy HH:mm:ss",
  },
  {
    value: "dd/MM/yyyy HH:mm",
    label: "dd/MM/yyyy HH:mm",
  },
  {
    value: "dd-MM-yyyy HH:mm",
    label: "dd-MM-yyyy HH:mm",
  },
  {
    value: "dd/MM/yy",
    label: "dd/MM/yy",
  },
  {
    value: "dd-MM-yy",
    label: "dd-MM-yy",
  },
  {
    value: "dd/MM/yyyy",
    label: "dd/MM/yyyy",
  },
  {
    value: "dd-MM-yyyy",
    label: "dd-MM-yyyy",
  },
  {
    value: "yyyy-MM-dd HH:mm:ss",
    label: "yyyy-MM-dd HH:mm:ss",
  },
  {
    value: "yyyy-MM-dd HH:mm",
    label: "yyyy-MM-dd HH:mm",
  },
  {
    value: "yyyy-MM-dd",
    label: "yyyy-MM-dd",
  },
];

export const CONTAINER_NAME_REGEX = /^(?=.{3,63}$)[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * Validates a Quartz Cron Expression as per FreeFormatter/Quartz Scheduler:
 * 1. Seconds (0-59)
 * 2. Minutes (0-59)
 * 3. Hours (0-23)
 * 4. Day of Month (1-31, supports ? * / - L W)
 * 5. Month (1-12 or JAN-DEC)
 * 6. Day of Week (1-7 or SUN-SAT, supports ? * / - L #)
 * 7. Year (optional, 1970-2099)
 *
 * Examples:
 * "0 0 23 ? * * *"     - Every day at 11:00 PM
 * "0 0/15 * * * ?"     - Every 15 minutes
 * "0 0 12 ? * MON-FRI" - Every weekday at 12:00 PM
 * "0 0 10 L * ?"       - 10:00 AM on the last day of every month
 */
export const CRON_REGEX =
  /^((\*|[0-5]?\d)(-[0-5]?\d)?(,[0-5]?\d)*(\/[0-5]?\d)?)[ ]+((\*|[0-5]?\d)(-[0-5]?\d)?(,[0-5]?\d)*(\/[0-5]?\d)?)[ ]+((\*|[01]?\d|2[0-3])(-[01]?\d|-2[0-3])?(,[01]?\d|,2[0-3])*(\/[01]?\d|\/2[0-3])?)[ ]+((\*|\?|L|([1-9]|[12]\d|3[01])(W|L)?|([1-9]|[12]\d|3[01])(-[1-9]|-12\d|-3[01])?(,[1-9]|,12\d|,3[01])*(\/([1-9]|[12]\d|3[01]))?))[ ]+((\*|([1-9]|1[0-2])(-[1-9]|-1[0-2])?(,[1-9]|,1[0-2])*(\/([1-9]|1[0-2]))?|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec))[ ]+((\*|\?|L|[1-7](L|#[1-5])?|[1-7](-[1-7])?(,[1-7])*(\/[1-7])?|sun|mon|tue|wed|thu|fri|sat))[ ]?((\*|(19[7-9]\d|20\d\d))(- (19[7-9]\d|20\d\d))?(,(19[7-9]\d|20\d\d))*(\/(19[7-9]\d|20\d\d))?)?$/i;

export const INTEGER_ONLY_REGEX = /^[1-9][0-9]*$/;

export const emailOrDomainValidator = (value: string): boolean =>
  EMAIL_REGEX.test(value) || EMAIL_DOMAIN_REGEX.test(value);

export const getOptionValue = (item: unknown): string => {
  if (typeof item === "string") {
    return item;
  }
  if (item && typeof item === "object" && "value" in item) {
    return String((item as { value: unknown }).value ?? "");
  }
  return "";
};

export const ACTIVE_DIALOG_OPTIONS_FOR_REPORT = [
  "execute",
  "status",
  "cron",
  "tags",
] as const;

export const ENABLE_DATA_SUBSTITUTION_TYPE = [
  "Type 14",
  "Type 15",
  "Type 17",
  "Type 19",
  "Type 20",
  "Type 22",
  "Type 23",
];

export const meterGroupTableColumns = [
  { key: "groupName", label: "Name" },
  { key: "groupDescription", label: "Description" },
  { key: "noOfMeters", label: "No. of Meters" },
] as const;

export const MISSING_DATA_HANDLING_ENEM12 = [
  {
    value: "NONE",
    label: "None",
  },
  {
    value: "LOCF",
    label: "Interpolate (LOCF)",
  },
  {
    value: "LINEAR",
    label: "Interpolate - Linear",
  },
  {
    value: "EXCLUDE_NULL_DATA",
    label: "Exclude null Data",
  },
];

export const WARNING_MESSAGE =
  "Cron Scheduler minute component should be only set for 0 minutes when using Hour report period";

export const oldMeterGroupTableColumns = [
  { key: "group_name", label: "Name" },
  { key: "group_description", label: "Description" },
  { key: "no_of_meters", label: "No Of Meters" },
] as const;

export const CRON_EXPRESSION_HELP_LINK =
  "https://singhajit.com/tools/quartz-scheduler/";

export const GAS_METER_UNIT = [
  {
    value: "I",
    label: "Imperial",
  },
  {
    value: "M",
    label: "Metric",
  },
];

export const MISSING_DATA_HANDLING_MDN = [
  {
    value: "LOCF",
    label: "LOCF",
  },
  {
    value: "Exclude Null",
    label: "Exclude null Data",
  },
];

export const MDN_TYPE_OF_READ = [
  {
    value: "A",
    label: "Actual",
  },
  {
    value: "E",
    label: "Estimated",
  },
  {
    value: "S",
    label: "Substituted",
  },
  {
    value: "C",
    label: "Customer Own Read",
  },
];

export const MDN_REASON_FOR_READ = [
  {
    value: "SRF",
    label: "Special Final Read",
  },
  {
    value: "SRR",
    label: "Special Reference Read",
  },
  {
    value: "SRA",
    label: "Special Account Investigation",
  },
  {
    value: "SRD",
    label: "Special Disconnection",
  },
  {
    value: "SRT",
    label: "Special Transfer Read",
  },
  {
    value: "SCH",
    label: "Schedule Cycle Read",
  },
  {
    value: "INI",
    label: "Meter Installation Read",
  },
  {
    value: "REM",
    label: "Meter Remove",
  },
  {
    value: "OSO",
    label: "Other Service Order",
  },
  {
    value: "MDV",
    label: "Meter Data Verify (residual)",
  },
];

export const REPORT_TYPE_VALUES = {
  eNem12: "Enem12ReportExecutionLogs",
  nem12: "NEM12ReportExecutionLogs",
  qualityFlag: "NEM12QualityFLagReport",
  meterEvent: "MeterEventReport",
  mdn: "MDNReportExecutionLogs",
  orion: "OrionReportExecutionLogs",
  siteUsage: "SiteUsageReportExecutionLogs",
} as const;

export type ReportTypeValue =
  (typeof REPORT_TYPE_VALUES)[keyof typeof REPORT_TYPE_VALUES];

export const REPORT_TYPE_LABELS = {
  eNem12: "eNEM12",
  nem12: "NEM12",
  qualityFlag: "Quality Flag",
  meterEvent: "Meter Event",
  mdn: "MDN",
  orion: "Orion",
  siteUsage: "Site Usage",
} as const;

export const REPORT_TYPE_LABEL_BY_VALUE: Record<ReportTypeValue, string> = {
  [REPORT_TYPE_VALUES.eNem12]: REPORT_TYPE_LABELS.eNem12,
  [REPORT_TYPE_VALUES.nem12]: REPORT_TYPE_LABELS.nem12,
  [REPORT_TYPE_VALUES.qualityFlag]: REPORT_TYPE_LABELS.qualityFlag,
  [REPORT_TYPE_VALUES.meterEvent]: REPORT_TYPE_LABELS.meterEvent,
  [REPORT_TYPE_VALUES.mdn]: REPORT_TYPE_LABELS.mdn,
  [REPORT_TYPE_VALUES.orion]: REPORT_TYPE_LABELS.orion,
  [REPORT_TYPE_VALUES.siteUsage]: REPORT_TYPE_LABELS.siteUsage,
};

export const isReportTypeValue = (value: string): value is ReportTypeValue =>
  Object.values(REPORT_TYPE_VALUES).includes(value as ReportTypeValue);

export const REPORT_TYPES: ReadonlyArray<{
  value: ReportTypeValue;
  label: string;
}> = [
  {
    value: REPORT_TYPE_VALUES.eNem12,
    label: REPORT_TYPE_LABELS.eNem12,
  },
  {
    value: REPORT_TYPE_VALUES.nem12,
    label: REPORT_TYPE_LABELS.nem12,
  },
  {
    value: REPORT_TYPE_VALUES.qualityFlag,
    label: REPORT_TYPE_LABELS.qualityFlag,
  },
  {
    value: REPORT_TYPE_VALUES.meterEvent,
    label: REPORT_TYPE_LABELS.meterEvent,
  },
  {
    value: REPORT_TYPE_VALUES.mdn,
    label: REPORT_TYPE_LABELS.mdn,
  },
  {
    value: REPORT_TYPE_VALUES.orion,
    label: REPORT_TYPE_LABELS.orion,
  },
  {
    value: REPORT_TYPE_VALUES.siteUsage,
    label: REPORT_TYPE_LABELS.siteUsage,
  },
];

export const EXECUTION_TYPE = [
  {
    value: "Adhoc",
    label: "Adhoc",
  },
  { value: "Scheduled", label: "Scheduled" },
  { value: "Resend", label: "Resend" },
];

export const REPORT_HISTORY_EXECUTION_TYPE = EXECUTION_TYPE.map((option) =>
  option.value === "Scheduled"
    ? {
        value: "Scheduler",
        label: "Scheduler",
      }
    : option,
);

export const REPORT_LOGS_STATUS = [
  {
    value: "Started",
    label: "Started",
  },
  {
    value: "Completed",
    label: "Completed",
  },
  {
    value: "Failed",
    label: "Failed",
  },
  { value: "Partial Data", label: "Partial Data" },
  {
    value: "Pending",
    label: "Pending",
  },
];

export const SEARCH_FIELDS_FOR_UNMAPPED_METERS: AddMeterSearchField[] = [
  { id: "meterName", label: "Meter", placeholder: "Filter by meter" },
  {
    id: "meterPropertyNumber",
    label: "Property Number",
    placeholder: "Filter by property number",
  },
  {
    id: "meterSerialNumber",
    label: "Serial Number",
    placeholder: "Filter by serial number",
  },
  { id: "nmi", label: "NMI", placeholder: "Filter by NMI" },
  {
    id: "propertyName",
    label: "Property Name",
    placeholder: "Filter by property name",
  },
  {
    id: "companyId",
    label: "Company",
    placeholder: "Select Company",
    type: "select",
  },
  { id: "isActive", label: "Show Inactive", type: "checkbox" },
];

export const mapOrderByToApiForMappedMeters = (orderKey: string): string => {
  switch (orderKey) {
    case "meterId":
      return "meter_id";
    case "meterPropertyNumber":
      return "meter_property_number";
    case "meterSerialNumber":
      return "meter_serial_number";
    case "nmi":
      return "nmi";
    case "name":
      return "property_name";
    case "active":
      return "status";
    case "customerName":
      return "customer_name";
    default:
      return orderKey;
  }
};

export const STATUS_COLOR_CLASS: Record<string, string> = {
  completed: "completed-badge",
  failed: "failed-badge",
  started: "started-badge",
  "partial data": "partial-data-badge",
  pending: "pending-badge",
};

export const DATA_VALIDATION_RULE_NAME = {
  offlineMeter: "Offline meter",
  missingData: "Missing data",
  zeroUsage: "Zero usage",
  spike: "Spike",
  cumulativeValueErrors: "Cumulative value errors",
};
